// frontend/src/components/admin/AdminLayout.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    LayoutDashboard,
    Users,
    Trophy,
    Settings,
    BarChart3,
    CreditCard
} from 'lucide-react';

const navItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/admin' },
    { icon: Users, label: 'Usuarios', path: '/admin/users' },
    { icon: Trophy, label: 'Torneos', path: '/admin/tournaments' },
    { icon: CreditCard, label: 'Transacciones', path: '/admin/transactions' },
    { icon: BarChart3, label: 'Estadísticas', path: '/admin/stats' },
    { icon: Settings, label: 'Configuración', path: '/admin/settings' },
];

const AdminLayout = ({ children }) => {
    const location = useLocation();

    const isActiveLink = (path) => location.pathname === path;

    return (
        <div className="min-h-screen flex" style={{ backgroundColor: '#0A1929' }}>
            {/* Sidebar */}
            <aside className="w-64 flex-shrink-0" style={{ backgroundColor: '#0E2238' }}>
                <div className="p-6 border-b" style={{ borderColor: '#122436' }}>
                    <h2 className="text-xl font-bold" style={{ color: '#FCE503' }}>Panel Admin</h2>
                </div>
                <nav className="mt-2">
                    {navItems.map((item) => {
                        const Icon = item.icon;
                        const isActive = isActiveLink(item.path);

                        return (
                            <Link
                                key={item.path}
                                to={item.path}
                                className="flex items-center px-6 py-3 text-sm transition-colors"
                                style={{
                                    backgroundColor: isActive ? '#122436' : 'transparent',
                                    color: isActive ? '#FCE503' : '#9ca3af',
                                }}
                                onMouseEnter={e => {
                                    if (!isActive) {
                                        e.currentTarget.style.backgroundColor = '#122436';
                                        e.currentTarget.style.color = '#FCE503';
                                    }
                                }}
                                onMouseLeave={e => {
                                    if (!isActive) {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.color = '#9ca3af';
                                    }
                                }}
                            >
                                <Icon className="w-5 h-5 mr-3" />
                                {item.label}
                            </Link>
                        );
                    })}
                </nav>
            </aside>

            {/* Main Content */}
            <main className="flex-1 overflow-auto">
                <div className="p-8">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default AdminLayout;
